export const MEDIA_FILE_MIME_TYPES =
  "image/jpg,image/jpeg,image/png,image/gif,video/mp4,text/vcard";
